export enum TimescaleTypes {
  MIN5 = '5m',

}



// WEBPACK FOOTER //
// ./src/app/chart/timescale.types.ts